import bcp from 'assets/images/svg/new-plan/header/bcp.svg';
enum AutoefectivoPriceEnums {
    lowest = '65',
    highest = '75',
    taxiLowest = '85',
    taxiHighest = '95',
    bcpLowest = '29.90',
    bcpHighest = '39.90',
}

export default AutoefectivoPriceEnums  
